'use strict';

var angularModule = angular.module('t2g.common.data-access.customer', []);

module.exports = angularModule;

angularModule.factory('CustomerResource', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/v2/customer/:customerId/:subResource';

  var resource = $resource(
    resourceUrl,
    {},
    {
      delete: { method: 'delete' },
      get: { method: 'get', isArray: false },
      insert: { method: 'post' },
      update: { method: 'put', params: { customerId: '@_id' } },
      getAppointments: { method: 'get', params: { subResource: 'appointments' }, isArray: false },
    },
  );

  return resource;
});

angularModule.factory('CustomerDA', function($q, CustomerResource) {
  var customerCache = [];
  var filteredCustomerCache = [];

  return {
    get: get,
    clearCache: clearCache,
    updateCustomers: updateCustomers,
    getAppointments: getAppointments,
    getFiltered: getFiltered,
    insert: insert,
    list: list,
    remove: remove,
    setFiltered: setFiltered,
    update: update,
  };

  /**
   * get one customer profile
   * @param {String} customerId
   * @returns {Promise}
   */
  function get(customerId) {
    var params = {
      customerId: customerId,
    };

    return CustomerResource.get(params).$promise.then(function(response) {
      return response.customer;
    });
  }

  /**
   * clear customers cache
   */
  function clearCache() {
    customerCache = [];
  }

  /**
   * update customers cache
   */
  function updateCustomers(newCustomers) {
    customerCache = customerCache.concat(newCustomers);
  }

  /**
   * get all appointments of a customer
   * @param {String} customerId
   * @returns {Promise}
   */
  function getAppointments(customerId, start, end) {
    var params = {
      customerId: customerId,
    };

    if (start && end && moment(start).isValid() && moment(end).isValid()) {
      params.start = moment(start).format('YYYY-MM-DD');
      params.end = moment(end).format('YYYY-MM-DD');
    }

    return CustomerResource.getAppointments(params).$promise.then(function(response) {
      return response.appointments;
    });
  }

  /**
   * get filtered customer list
   * @returns {Array}
   */
  function getFiltered() {
    return filteredCustomerCache;
  }

  /**
   * save customer
   * @param {Object} customer object
   * @returns {Promise}
   */
  function insert(customer) {
    return CustomerResource.insert(customer).$promise.then(function(response) {
      customerCache.push(response.customer);
      return response.customer;
    });
  }

  /**
   * get list of all customers
   * @returns {Promise}
   */
  function list() {
    if (customerCache.length > 0) {
      return $q.when(customerCache);
    } else {
      return CustomerResource.get().$promise.then(function(response) {
        customerCache = response.customers;
        return response.customers;
      });
    }
  }

  /**
   * remove a customer
   * @param {String} customerId
   * @returns {Promise}
   */
  function remove(customerId) {
    return CustomerResource.delete({ customerId: customerId }).$promise.then(function() {
      _.remove(customerCache, { _id: customerId });
      return true;
    });
  }

  /**
   * set filtered customer list
   * @param filteredCustomer
   */
  function setFiltered(filteredCustomer) {
    filteredCustomerCache = filteredCustomer;
  }

  /**
   * update a customer
   * @param {Object} customer object
   * @returns {Promise}
   */
  function update(customer) {
    return CustomerResource.update(customer).$promise.then(function(response) {
      var cachedCustomerIndex = _.findIndex(customerCache, { _id: customer._id });

      if (response.customer.birthday) {
        response.customer.birthday = new Date(response.customer.birthday);
      }

      customerCache[cachedCustomerIndex] = response.customer;

      console.log(response.customer);
      return response.customer;
    });
  }
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/customer.js